module.exports = __webpack_public_path__ + "fd83919156897cb89c52ec196037ab7e.jpg";